export default __webpack_public_path__ + "static/media/eye-off.2dc02b0c.svg";